module.exports = __webpack_public_path__ + "img/71.a5355fd8.png";